import { useAuth0 } from "@auth0/auth0-react";
import { useState, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import itemStyles from '../components/TransactionItem/TransactionSuggestion.module.css'
import LoadingSpinner from '../components/ui/LoadingSpinner'
import TransactionSuggestion from '../components/TransactionItem/TransactionSuggestion'
import { scrollToTop } from '../utilities/general-utils';
import { normalizeRawTransactionTemplate } from '../utilities/data-normalization';
import { svc_getTransactionTemplates, svc_getTransactions } from '../services/transaction.service';


function TransactionsSuggestions() {
    const { getAccessTokenSilently, user } = useAuth0();
    const gridRef = useRef(null)
    const [templatesList, setTemplatesList] = useState(null)
    const [isLoading, setIsLoading] = useState(true)
    const [isEditing, setIsEditing] = useState(false)
    const [categoryFilter, setCategoryFilter] = useState('')
    const [categories, setCategories] = useState([])

    const handleEditClick = (itemExpanded, itemRef = null) => {
        setIsEditing(!isEditing)

        const itemToScrollTo = itemRef ? itemRef : gridRef.current
        const offsetModifier = itemRef ? itemRef.getBoundingClientRect().top : -50

        if (itemExpanded) {
            setTimeout(() => scrollToTop(itemToScrollTo, offsetModifier), 350)
        }
    }
        
    const getTransactionsAndTemplates = async () => {
        const accessToken = await getAccessTokenSilently();
        const { data : templates } = await svc_getTransactionTemplates(accessToken);
        const { data : transactions } = await svc_getTransactions(accessToken, user.sub);

        const transactionsCreatedWithTemplate = await transactions.filter(transaction => transaction.template_id !== null) || []

        if (templates) {
            const normalizedData = adjustTemplateDataDefaults(templates, transactionsCreatedWithTemplate)
            setTemplatesList(normalizedData)

            const categories = normalizedData.map(item => item.category).sort()
            setCategories([...new Set(categories)])
        }

        setIsLoading(false)
    }

    const adjustTemplateDataDefaults = (templates, transactions) => (
        templates.map(template => {
            return {
                ...normalizeRawTransactionTemplate(template),
                templateId: template.id,
                createdTransactions: transactions
                    .filter(transaction => transaction.template_id === template.id)
                    .map(transaction => {
                        return {
                            id: transaction.id,
                            title: transaction.title
                        }
                    }) || []
            }
        })
    )

    const handleFilterChange = (e) => {
        setCategoryFilter(e.target.value)
    }

    const filterFunc = (item) => {
        if (!categoryFilter) {
            return true
        }

        return item.category === categoryFilter
    }

    useEffect(() => {
        if (!templatesList) {
            getTransactionsAndTemplates()
        }
    }, [templatesList])

    return (
        <div style={{margin: '0 auto'}}>
            <div>
                <h1 className='text-center'>Get Started With Common Transactions</h1>

                <h5 className='text-center'>
                   Select from typical expenses to quickly set up your budget
                </h5>
                
                <p className='text-center'>
                    These are common transactions you can use to quickly set up your budget. You can edit or delete them later.
                </p>
            </div>

            {isLoading ? (
                <LoadingSpinner />
            ) : (
                templatesList && templatesList.length && (
                    <div className="content-width-container">
                        {!isEditing &&
                            <div className="formField" style={{
                                width: '100%',
                                maxWidth: '400px',
                            }}>
                                <label>Category Filter</label>
                                <select onChange={handleFilterChange} defaultValue={categoryFilter}>
                                    <option value=''>All Categories</option>
                                    {categories.map((category, index) => (
                                        <option key={index} value={category}>{category}</option>
                                    ))}
                                </select>
                            </div>
                        }

                        <div
                            className={`${itemStyles.itemsWrap} ${isEditing ? itemStyles.hasExpandedItem : null}`}
                            ref={gridRef}
                        >
                            {templatesList
                                ? templatesList.filter(filterFunc).map(item =>
                                    <TransactionSuggestion
                                        key={item.templateName + item.amount} item={item}
                                        onEdit={handleEditClick}
                                    />
                                ) : null
                            }
                        </div>
                    </div>
                )
            )}

            <div className='text-center'>
                <h3>Don't see what you're looking for?</h3>
                <p className='text-center'>
                    If you'd like to create a transaction from scratch, click the button below.
                </p>

                <Link className='button button-green' to={`/add-transaction`}>
                    Add New Transaction
                </Link>
            </div>
        </div>
    )
}

export default TransactionsSuggestions
